import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { CaseOverviewResponse } from '@/api';

interface CaseOverviewState {
  caseOverview: CaseOverviewResponse | null;
}

const initialState: CaseOverviewState = {
  caseOverview: null
};

const caseOverviewSlice = createSlice({
  name: 'caseOverview',
  initialState: initialState,
  reducers: {
    setCaseOverview: (state, action: PayloadAction<CaseOverviewResponse>) => {
      state.caseOverview = action.payload;
    }
  }
});

export const { setCaseOverview } = caseOverviewSlice.actions;

export const selectCaseOverview = (state: RootState) => {
  return state.caseOverview.caseOverview;
};

export const caseOverviewReducer = caseOverviewSlice.reducer;
